import React, { useEffect, useState } from "react";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";

function Dashboard() {
  const { userId } = useSelector((state) => state.Auth);
  const jwt_token = sessionStorage.getItem("jwt_token");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dash, setDash] = useState([]);

  const Dashboard_API = async () => {
    try {
      let responceRight = await API?.get(`/AdminDashboard?loginid=${userId}`, {
        headers: {
          Authorization: jwt_token,
        },
      });
      responceRight = responceRight.data.data[0][0];
      console.log("Dashboard--->", responceRight);
      setDash(responceRight);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    Dashboard_API();
  }, []);

  return (
    <div>
      <Navbar />
      <>
        <div id="wrapper">
          <div class="content-page page_scroll_y">
            <div class="content">
              <div class="container">
                <div class="row">
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Member_Details">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Registration</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalUser}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Member_Details">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Registration</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayUser}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Member_Details">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Activation</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalactivation}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Member_Details">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Activation</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayactivation}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Member_Details">
                          <div class="gcp-description">
                            <div class="gcp-title">Total CTO</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.totalInvest}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Member_Details">
                          <div class="gcp-description">
                            <div class="gcp-title">Today CTO</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.todayInvest}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/Direct_Income">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Direct Income</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.Directincome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/Direct_Income">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Direct Income</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.T_Directincome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/RoiIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Total ROI Income</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.roiincome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/RoiIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Today ROI Income</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.T_roiincome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/LevelIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Roi Level Income</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.Levelincome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/LevelIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Roi Level Income</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.T_Levelincome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  {/* <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/LeadershipIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Leadership Income</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.LeadershipIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/LeadershipIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Leadership Income</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.T_LeadershipIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>  */}
                  {/* <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/Salary_Income">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Leadership Income</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.T_Salaryincome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/Salary_Income">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Leadership Income</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.Salaryincome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div> */}
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Pending Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalPendingWithdrawal}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Pending Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayPendingWithdrawal}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Paid Withdrawal</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {" "}
                                {dash.totalPaidWithdrawal}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Paid Withdrawal</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayPaidWithdrawal}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
}

export default Dashboard;
